// ToggleButton.tsx
import React from 'react';

const ToggleButton = ({
  isOn,
  onToggle,
  onLabel = 'On',
  offLabel = 'Off',
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <button
        type="button"
        onClick={onToggle}
        className={`
          relative inline-flex h-[25px] w-[44px] items-center rounded-full transition-colors shadow 
          focus:outline-none  focus:ring-offset-2
          border border-gray-200 hover:border-gray-300
          ${isOn ? 'bg-white border border-gray-300' : 'bg-white border border-gray-300'}
        `}
        aria-pressed={isOn}
      >
        <span
          className={`
             h-5 w-5 transform rounded-full  shadow-md
            transition-all duration-300 ease-in-out
            flex items-center justify-center
            border border-gray-200
            ${isOn ? 'translate-x-5 bg-[#F87171]' : 'translate-x-1 bg-[#60A5FA]'}
          `}
        >
         
        </span>
      </button>
      {/* <span className={`text-sm font-medium ${isOn ? 'text-gray-800' : 'text-gray-600'}`}>
        {isOn ? onLabel : offLabel}
      </span> */}
    </div>
  );
};

export default ToggleButton;